import {Action, di, lazyGet} from "@dp-instant/core";
import {TypesAds, TypesAudio} from "@dp-instant/interfaces";
import {AdAction, IUser} from "@dp-instant/social";
import {IRankableUser} from "@game/ui/interface/IRankableUser";
import {Playdeck} from "./coregame/utils/Playdeck";
import {apiClient} from "./api/ApiClient";

export const isRankableUser = (user: IUser | IRankableUser): user is IRankableUser => {
    return (user as IRankableUser).getLbRecord !== undefined;
};

export const showAd = async (placement?: string) =>
    await di.get<AdAction>(TypesAds.adAction).showAd(placement);

export const showReward = async (hasVip: boolean) => {
    if (hasVip) return true;

    return await Playdeck.showAd();
};

export const showRewardOrPay = async (hasVip: boolean, starsSlug?: string): Promise<boolean> => {
    if (hasVip) return true;
    if (__SOCIAL__ === "tg" && starsSlug) {
        try {
            const {paid} = await apiClient.purchaseFlow(starsSlug);
            return paid;
        } catch {
            return false;
        }
    }
    return await Playdeck.showAd();
};

export const playSound = async (name: string) =>
    lazyGet<Action<string>>(TypesAudio.soundAction)?.run(name);

export const playUIClickSound = () => {
    playSound("click_ui");
};
